import { useQuery } from "@tanstack/react-query";
import { getNotificationCountByCompany } from "../action/getNotificationCountByCompany";

export const NOTIFICATION_COUNT_BY_COMPANY_QUERY_KEY = ["notification-count-by-company"];

export const useNotificationCountByCompany = () => {
  return useQuery({
    queryKey: NOTIFICATION_COUNT_BY_COMPANY_QUERY_KEY,
    queryFn: getNotificationCountByCompany,
    retry: 0,
    refetchOnWindowFocus: true,
  });
};
